export default function Footer() {
  const year = new Date().getFullYear();
  return <main className="w-full font-bold text-center py-3 bg-zinc-800 text-white">Copyright &copy; TRUST ZONE 2018 - {year}</main>;
}
